import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { subDays as b, format as t, addDays as L, startOfWeek as S, endOfWeek as D, parse as F } from "date-fns";
import { useState as m } from "react";
import { useTranslation as H } from "react-i18next";
import T from "classnames";
import K from "../Select/index.js";
import V from "./ModalChooseDate/index.js";
const q = "forma-ui__dataSelect__dateInputItem", z = "forma-ui__dataSelect__customPeriod", G = "forma-ui__dataSelect__customOption", J = "forma-ui__dataSelect__selected", d = {
  dateInputItem: q,
  customPeriod: z,
  customOption: G,
  selected: J
}, Q = ["allTime", "today", "yesterday", "weekNow", "weekLast"], ee = ({ placeholder: P, onChangeDate: o }) => {
  const { t: i } = H(), [W, u] = m(!1), [r, p] = m(""), [n, y] = m(""), l = /* @__PURE__ */ new Date();
  l.setHours(0, 0, 0, 0);
  const v = b(l, 7), M = t(l, "dd.MM.yyyy"), A = L(l, 1), k = b(l, 1), h = t(k, "dd.MM.yyyy"), f = S(l, { weekStartsOn: 1 }), w = D(l, { weekStartsOn: 1 }), _ = S(v, { weekStartsOn: 1 }), I = D(v, { weekStartsOn: 1 }), N = `${t(f, "dd.MM")} - ${t(w, "dd.MM.yyyy")}`, O = `${t(_, "dd.MM")} - ${t(I, "dd.MM.yyyy")}`, $ = (c) => {
    const [s, B] = c.split(" - ").map((E) => F(E, "dd.MM.yyyy", /* @__PURE__ */ new Date()));
    o(t(s, "yyyy-MM-dd"), t(L(B, 1), "yyyy-MM-dd")), p(c), y(c);
  }, x = (c) => {
    const s = c.target.value;
    s === "allTime" ? o("allTime", "allTime") : s === "today" ? o(t(l, "yyyy-MM-dd"), t(A, "yyyy-MM-dd")) : s === "yesterday" ? o(t(k, "yyyy-MM-dd"), t(l, "yyyy-MM-dd")) : s === "weekNow" ? o(t(f, "yyyy-MM-dd"), t(w, "yyyy-MM-dd")) : s === "weekLast" && o(t(_, "yyyy-MM-dd"), t(I, "yyyy-MM-dd")), p(s), y("");
  }, j = [
    {
      value: "allTime",
      label: /* @__PURE__ */ e("div", { children: i("uikit:all_time") }),
      displayLabel: /* @__PURE__ */ e("div", { children: i("uikit:all_time") })
    },
    {
      value: "today",
      label: /* @__PURE__ */ a("div", { children: [
        /* @__PURE__ */ e("div", { children: i("uikit:today") }),
        " ",
        /* @__PURE__ */ e("div", { className: d.dateInputItem, children: M })
      ] }),
      displayLabel: /* @__PURE__ */ a("div", { children: [
        /* @__PURE__ */ e("div", { children: i("uikit:today") }),
        " ",
        /* @__PURE__ */ e("div", { className: d.dateInputItem, children: M })
      ] })
    },
    {
      value: "yesterday",
      label: /* @__PURE__ */ a("div", { children: [
        /* @__PURE__ */ e("div", { children: i("uikit:yesterday") }),
        " ",
        /* @__PURE__ */ e("div", { className: d.dateInputItem, children: h })
      ] }),
      displayLabel: /* @__PURE__ */ a("div", { children: [
        /* @__PURE__ */ e("div", { children: i("uikit:yesterday") }),
        " ",
        /* @__PURE__ */ e("div", { className: d.dateInputItem, children: h })
      ] })
    },
    {
      value: "weekNow",
      label: /* @__PURE__ */ a("div", { children: [
        /* @__PURE__ */ e("div", { children: i("uikit:now_week") }),
        " ",
        /* @__PURE__ */ e("div", { className: d.dateInputItem, children: N })
      ] }),
      displayLabel: /* @__PURE__ */ a("div", { children: [
        /* @__PURE__ */ e("div", { children: i("uikit:now_week") }),
        " ",
        /* @__PURE__ */ e("div", { className: d.dateInputItem, children: N })
      ] })
    },
    {
      value: "weekLast",
      label: /* @__PURE__ */ a("div", { children: [
        /* @__PURE__ */ e("div", { children: i("uikit:last_week") }),
        " ",
        /* @__PURE__ */ e("div", { className: d.dateInputItem, children: O })
      ] }),
      displayLabel: /* @__PURE__ */ a("div", { children: [
        /* @__PURE__ */ e("div", { children: i("uikit:last_week") }),
        " ",
        /* @__PURE__ */ e("div", { className: d.dateInputItem, children: O })
      ] })
    }
  ];
  return /* @__PURE__ */ a("div", { className: d.select, children: [
    /* @__PURE__ */ e(
      K,
      {
        name: "filter_group",
        onChange: x,
        placeholder: P ?? i("uikit:period"),
        className: T(d.selectDate, r && !Q.includes(r) && d.customPeriod),
        value: r,
        options: j,
        meta: {
          customLabelKey: "displayLabel",
          afterDropdownButton: /* @__PURE__ */ e("div", { className: "rc-virtual-list-holder", children: /* @__PURE__ */ e(
            "div",
            {
              className: T("rc-select-item rc-select-item-option", d.customOption, n && d.selected),
              onMouseDown: () => u(!0),
              children: /* @__PURE__ */ e("div", { className: "rc-select-item-option-content", children: /* @__PURE__ */ a("div", { children: [
                /* @__PURE__ */ e("div", { children: i(n ? "uikit:selected_period" : "uikit:select_period") }),
                " ",
                n && /* @__PURE__ */ e("div", { className: d.dateInputItem, children: n })
              ] }) })
            }
          ) })
        }
      }
    ),
    /* @__PURE__ */ e(
      V,
      {
        open: W,
        onClose: () => u(!1),
        onApply: $,
        onCancel: () => y("")
      }
    )
  ] });
};
export {
  ee as default
};
